/**
 * 창업지원 페이지 컴포넌트
 * 창업지원 프로그램 정보를 제공하는 페이지입니다.
 */

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import SubPage from '../template/SubPage';
import { MENU_DATA, getSubMenuLabel } from '../constant/menuData';
import { startupProgram } from '../constant/startupData';
import MyHelmet from '../hooks/Helmet';

function StartupPage() {
  const no = useParams().no;
  const [submenu, setSubMenu] = useState('창업지원 프로그램');

  // 메뉴 데이터 가져오기
  const menuData = MENU_DATA.startup;

  useEffect(() => {
    setSubMenu(getSubMenuLabel('startup', no) || '창업지원 프로그램');
  }, [no]);

  // 콘텐츠 렌더링
  const renderContent = () => {
    if (no === '1') {
      // 창업지원 프로그램 콘텐츠
      return (
        <ContentContainer>
          {startupProgram.sections.map((section) => (
            <InfoSection key={section.id}>
              <SectionTitle>{section.title}</SectionTitle>
              {section.content.map((item, index) => (
                <Description key={index}>{item.text}</Description>
              ))}
            </InfoSection>
          ))}
        </ContentContainer>
      );
    }
  };

  return (
    <>
      <MyHelmet />
      <SubPage
        title={menuData.label}
        description={menuData.description}
        menuItems={menuData.subMenus}
        currentNo={no}
        submenuTitle={submenu}
        breadcrumbMenu={menuData.label}
        breadcrumbLink={menuData.path}
      >
        {renderContent()}
      </SubPage>
    </>
  );
}

export default StartupPage;

/* Styled Components */

const ContentContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  min-height: 400px;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    padding: 0 5%;
    width: 100%;
    max-width: 100%;
    min-height: 300px;
  }
`;

const InfoSection = styled.section`
  padding: 20px 0;
  margin-bottom: 30px;
  box-sizing: border-box;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    padding: 15px 0;
    margin-bottom: 20px;
  }
`;

const SectionTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0 0 20px 0;
  font-family: 'Nanum Gothic Bold';

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 18px;
    margin: 0 0 15px 0;
  }
`;

const Description = styled.p`
  font-size: 16px;
  color: #555;
  line-height: 1.8;
  margin: 10px 0;
  font-family: 'Nanum Gothic';

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 1.6;
    margin: 8px 0;
  }
`;
